var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeco1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.9051 -18V17.5798H0.18248C0.18248 -2.06026 15.7382 -18 34.9051 -18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.9051 17.5801V53.1599C15.7382 53.1599 0.18248 37.2201 0.18248 17.5801H34.9051Z",
    fill: "#4EA39A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.9051 17.5801C54.072 17.5801 69.6277 33.5198 69.6277 53.1599H34.9051V17.5801Z",
    fill: "#114CD6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco1);
export default __webpack_public_path__ + "static/media/deco1.e67b0a9f6757c6c7151641bf610d6314.svg";
export { ForwardRef as ReactComponent };